module.exports = __webpack_public_path__ + "img/flower-illustration.f6eb1fd9.svg";